import React from "react";
import { resolveColor } from "../blockTypeConstants";

const ProgressBarPreview = ({ blockItems, colorOptions = [] }) => {
    return (
        <>
            {blockItems.map((item, idx) => {
                const progressValue = Number(item?.value) || 0;
                const safeValue = Math.max(0, Math.min(100, progressValue));
                const progressColor = resolveColor(item?.barColor, colorOptions);

                return (
                    <div className="block-preview-card" key={`${item?.label || "Progress"}-${idx}`}>
                        <div className="progress-preview-row">
                            <span>{item?.label || ""}</span>
                            <span>{safeValue}%</span>
                        </div>
                        <div className="progress-preview-track">
                            <div className="progress-preview-fill" style={{ width: `${safeValue}%`, background: progressColor }} />
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default ProgressBarPreview;
